import { CARDS_EXTENSION_TYPE } from '@atlassian/cards-extension/constants';
import { carouselExtensionType } from '@atlassian/carousel-extension/constants';
import {
	RESOURCE_TILES_EXTENSION_TYPE,
	SECTION_EXTENSION_TYPE,
	SPOTLIGHT_EXTENSION_TYPE,
} from '@atlassian/company-hub-common/constants';
import { SEARCH_EXTENSION_TYPE } from '@atlassian/custom-search-extension/constants';
import { HUB_CONNECT_EXTENSION_TYPE } from '@atlassian/hub-connect-extension/constants';
import { HUB_ELEMENT_PLACEHOLDER_EXTENSION_TYPE } from '@atlassian/hub-element-placeholder/constants';
import { HUB_FORGE_EXTENSION_TYPE } from '@atlassian/hub-forge-extension/constants';
import { JSM_HELP_EXTENSION_TYPE } from '@atlassian/jsm-help-extension/constants';
import { LINKS_MENU_EXTENSION_TYPE } from '@atlassian/links-menu-extension/constants';
import { CALLOUT_BANNER_EXTENSION_TYPE } from '@atlassian/page-topper-extension/constants';

/**
 * Extension types whose config panel is allowed to open from the editor's
 * "edit" icon. Hub Forge + Hub Connect are gated by `forge-on-hubs` at the
 * insert-menu layer, so once a node exists in the document we always allow
 * its config panel to open — otherwise the user could never re-open the
 * panel after toggling the gate.
 */
export const ALLOWED_EXTENSIONS: string[] = [
	HUB_ELEMENT_PLACEHOLDER_EXTENSION_TYPE,
	SPOTLIGHT_EXTENSION_TYPE,
	CARDS_EXTENSION_TYPE,
	LINKS_MENU_EXTENSION_TYPE,
	SECTION_EXTENSION_TYPE,
	SEARCH_EXTENSION_TYPE,
	carouselExtensionType,
	RESOURCE_TILES_EXTENSION_TYPE,
	CALLOUT_BANNER_EXTENSION_TYPE,
	JSM_HELP_EXTENSION_TYPE,
	HUB_FORGE_EXTENSION_TYPE,
	HUB_CONNECT_EXTENSION_TYPE,
];
